"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapacidadesOrcadas = void 0;
var bson_1 = require("bson");
var CapacidadesOrcadas = /** @class */ (function () {
    function CapacidadesOrcadas(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CENTRO_TRAB, CENTRO_TRAB = _c === void 0 ? '' : _c, _d = _a.DT_VAL_INI, DT_VAL_INI = _d === void 0 ? '' : _d, _e = _a.FABRICA, FABRICA = _e === void 0 ? '' : _e, _f = _a.DT_VAL_FIM, DT_VAL_FIM = _f === void 0 ? '' : _f, _g = _a.MINUTOS, MINUTOS = _g === void 0 ? 0 : _g, _h = _a.NO, NO = _h === void 0 ? '' : _h, _j = _a.dataIni, dataIni = _j === void 0 ? new Date() : _j, _k = _a.dataFim, dataFim = _k === void 0 ? new Date() : _k, _l = _a.TIPO_NO, TIPO_NO = _l === void 0 ? '' : _l, _m = _a.DS_TIPO_NO, DS_TIPO_NO = _m === void 0 ? '' : _m, _o = _a.DATA, DATA = _o === void 0 ? '' : _o, _p = _a.minutosOrcado, minutosOrcado = _p === void 0 ? 0 : _p, _q = _a.dia, dia = _q === void 0 ? 0 : _q, _r = _a.minutosReal, minutosReal = _r === void 0 ? 0 : _r;
        this._id = _id;
        this.CENTRO_TRAB = CENTRO_TRAB;
        this.DT_VAL_INI = DT_VAL_INI;
        this.FABRICA = FABRICA;
        this.DT_VAL_FIM = DT_VAL_FIM;
        this.MINUTOS = MINUTOS;
        this.NO = NO;
        this.dataIni = dataIni;
        this.dataFim = dataFim;
        this.TIPO_NO = TIPO_NO;
        this.DS_TIPO_NO = DS_TIPO_NO;
        this.DATA = DATA;
        this.minutosOrcado = minutosOrcado;
        this.dia = dia;
        this.minutosReal = minutosReal;
    }
    return CapacidadesOrcadas;
}());
exports.CapacidadesOrcadas = CapacidadesOrcadas;
//# sourceMappingURL=CapacidadesOrcadas.js.map